/**
 * Theme tokens y styled components del flujo de reserva.
 *
 * Antes del refactor el degradado `linear-gradient(135deg,#667eea,#764ba2)`
 * estaba copiado 6 veces. Cualquier ajuste visual obligaba a tocar 6 archivos.
 * Aquí lo centralizamos junto con shadows, transitions y los componentes
 * styled más reutilizados.
 */

import { Card, Box, Button } from '@mui/material';
import { styled } from '@mui/material/styles';

// ============================================================================
// TOKENS
// ============================================================================

export const GRADIENT_PRIMARY = 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)';
export const GRADIENT_SUCCESS = 'linear-gradient(90deg, #667eea 0%, #764ba2 100%)';
export const GRADIENT_CONFIRM = 'linear-gradient(135deg, #4caf50 0%, #2e7d32 100%)';

export const SHADOW_CARD = '0 2px 12px rgba(0,0,0,0.08)';
export const SHADOW_CARD_LIFTED = '0 4px 20px rgba(0,0,0,0.1)';
export const SHADOW_FOOTER = '0 -2px 12px rgba(0,0,0,0.08)';

export const TRANSITION_DEFAULT = 'all 0.3s ease';

export const COLOR_PAGE_BG = '#f8f9fa';
export const COLOR_FIELD_BG_READONLY = '#f5f5f5';
export const COLOR_BORDER_NEUTRAL = '#e0e0e0';

// ============================================================================
// STYLED COMPONENTS
// ============================================================================

/** Card estándar de cada paso, con shadow consistente. */
export const StepCard = styled(Card)({
  marginBottom: 24,
  boxShadow: SHADOW_CARD
});

/** Header con degradado para cada step / sección destacada. */
export const StepHeader = styled(Box)({
  background: GRADIENT_PRIMARY,
  color: 'white',
  padding: 16,
  display: 'flex',
  alignItems: 'center',
  gap: 16
});

/** Botón primario con degradado, para "Siguiente paso" y similares. */
export const PrimaryButton = styled(Button)({
  paddingLeft: 32,
  paddingRight: 32,
  background: GRADIENT_PRIMARY,
  '&:hover': {
    background: GRADIENT_PRIMARY,
    opacity: 0.95
  }
});

/** Botón de confirmación (verde), para "Confirmar Reserva". */
export const ConfirmButton = styled(Button)(({ disabled }) => ({
  paddingLeft: 32,
  paddingRight: 32,
  background: disabled ? undefined : GRADIENT_CONFIRM,
  '&:hover': {
    background: GRADIENT_CONFIRM,
    opacity: 0.95
  }
}));
